import { _ } from "../../core/polyglot/polyglot.js";
import Period from "./Period.js";

const monthIds = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
];

/**
 * Todo: Add JSDoc comment
 */
export function getNames() {
	return [
		_("January"),
		_("February"),
		_("March"),
		_("April"),
		_("May"),
		_("June"),
		_("July"),
		_("August"),
		_("September"),
		_("October"),
		_("November"),
		_("December"),
	];
}

/**
 * `month` is a period representing month.
 * Instances should not be created by hand, but rather looked up
 * from `fiscalYear`.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} month
 */
export default class Month extends Period {
	constructor() {
		super(...arguments);
		this._periodId = monthIds[this.getStart().getMonth()];
		this._name = getNames()[this.getStart().getMonth()];
	}

	isMonth() {
		return true;
	}

	getGroupLabel() {
		return _("Months");
	}

	getCalendarIndex() {
		return this._year
			.asMonths()
			.findIndex((month) => this.hasSamePeriodIndex(month));
	}

	static getType() {
		return "Month";
	}
}
